/* eslint-disable */
import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ContactView from "../views/ContactView.vue";
import FeatureView from "../views/FeatureView.vue";
import PlanView from "../views/PlanView.vue";
import HallInformation from "../views/HallInformation.vue";
const titles = {
  hondo: "本渡斎場",
  itsuwa: "五和斎場",
  reihoku: "苓北斎場",
};
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/contact",
    name: "Contact",
    component: ContactView,
    meta: { title: "お問い合わせ" },
  },
  {
    path: "/feature",
    name: "Feature",
    component: FeatureView,
    meta: { title: "天聖閣の特徴" },
  },
  {
    path: "/plan",
    name: "Plan",
    component: PlanView,
    meta: { title: "御葬儀プラン" },
  },
  {
    path: "/information/:id",
    name: "HallInformation",
    component: HallInformation,
    props: true,
  },
  {
    path: "/about",
    name: "about",
    component: HallInformation,
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  scrollBehavior(to, from, savedPosition) {
    let Position = Object;
    return new Promise((resolve, reject) => {
      if (savedPosition) {
        Position = savedPosition;
      } else {
        Position = { left: 0, top: 0 };
      }
      setTimeout(() => {
        resolve(Position);
      }, 500);
    });
  },
});
router.afterEach((to, from) => {
  let setTitle = "総合葬祭式場 天聖閣（てんせいかく）";
  let setDesc =
    "大切な人との出会いに感謝し会葬者おひとりお一人が最期のお別れを告げる聖なる空間。厳かに格式高くお送りし、想いを伝える心温まるセレモニーをお手伝いさせていただきます。";
  if (to.params.id) {
    setTitle = titles[to.params.id] + " | 天聖閣（てんせいかく）";
  } else if (to.meta.title) {
    setTitle = to.meta.title + " | 天聖閣（てんせいかく）";
  }
  document.title = setTitle;
  document
    .querySelector("meta[name='description']")
    .setAttribute("content", setDesc);
});
export default router;
